import { useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import {
  Circle,
  FeatureGroup,
  LayerGroup,
  LayersControl,
  MapContainer,
  Marker,
  Pane,
  Popup,
  Rectangle,
  TileLayer,
  Tooltip,
  useMap,
  useMapEvents,
} from "react-leaflet";
import { LeafletMouseEvent } from "leaflet";
import { sortBy } from "lodash";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { setMapData, toggleMoveEnd } from "Redux/mapSlice";
import { throttle } from "Helper/general";
import useStations from "Hooks/useStations";
import { IStation } from "Types/station";
import { CEDARMAP_TOKEN } from "Constants/App";
import { Card, Typography } from "@mui/material";
import { Stack } from "@mui/system";

type AdressPoint = Array<[number, number, string]>;
interface IProps {
  children?: React.ReactNode;
  dragging?: boolean;
  position?: null | { lat: number; lng: number };
  singleStationData?: any;
}

function MapHandler({ zoom, singleStationData }: { zoom: number; singleStationData: any }) {
  const dispatch = useAppDispatch();

  const { view, bounds, minimize, updateShowStationMarker } = useAppSelector((state) => state.map);
  const { zone } = useAppSelector((state) => state.zones);
  const { ids } = useAppSelector((state) => state.stations);
  const { openCircle } = useAppSelector((state) => state.tooltip);
  const { data } = useStations();

  const eventFunction: (e: LeafletMouseEvent) => void = useMemo(
    () =>
      throttle(function (event: LeafletMouseEvent) {
        const { lat, lng } = event.latlng;
        dispatch(setMapData({ mouse: { lat, lng } }));
      }, 2000),
    []
  );

  const map = useMapEvents({
    moveend(e) {
      const { lat, lng } = map.getCenter();
      dispatch(toggleMoveEnd());
      dispatch(setMapData({ center: { lat, lng }, zoom: map.getZoom() }));
    },
    mousemove(e) {
      eventFunction(e);
    },
  });

  // useEffect(() => {
  //   if (map && !minimize) {
  //     map.setZoom(zoom);
  //   }
  // }, [zoom]);

  // useEffect(() => {
  //   if (view !== null) {
  //     map.setView(view.center, view.zoom);
  //   }
  // }, [view]);

  // useEffect(() => {
  //   if (bounds !== null && bounds.positions.length > 0) {
  //     map.fitBounds(bounds.positions, { padding: [200, 200], ...bounds.options });
  //   }
  // }, [bounds]);

  useEffect(() => {
    if (map && minimize) {
      map.flyTo([singleStationData.lat, singleStationData.lng], 12);
    }
  }, [minimize, updateShowStationMarker]);

  return <></>;
}

export default function Map({ children, dragging = true, position, singleStationData }: IProps) {
  const { zoom, center, minimize } = useAppSelector((state) => state.map);

  // const center = [51.505, -0.09];
  const rectangle = [
    [51.49, -0.08],
    [51.5, -0.06],
  ];

  return (
    <>
      <Helmet>
        {/* <script src="https://api.cedarmaps.com/cedarmaps.js/v1.8.0/cedarmaps.js" /> */}
        {/* <link href="https://api.cedarmaps.com/cedarmaps.js/v1.8.0/cedarmaps.css" rel="stylesheet" /> */}
      </Helmet>

      <MapContainer
        // center={position ? [position.lat, position.lng] : [center.lat, center.lng]}
        center={position ? [position.lat, position.lng] : [center.lat, center.lng]}
        // zoom={minimize ? 12 : zoom}
        zoom={12}
        zoomControl={false}
        zoomSnap={0}
        zoomDelta={0.5}
        style={{ width: "100%", height: "100%" }}
        dragging={dragging}
        scrollWheelZoom={true}
      >
        {/* <TileLayer
          attribution='<a href="https://www.cedarmaps.com/">Cedarmaps</a> map data'
          url={`https://api.cedarmaps.com/v1/tiles/cedarmaps.streets/{z}/{x}/{y}.png?access_token=${CEDARMAP_TOKEN}`}
        /> */}
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {children}
        <MapHandler zoom={zoom} singleStationData={singleStationData} />
      </MapContainer>
    </>
  );
}
